import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/payment-management"
const options = {role: ROLE.RESTAURANT};


export const paymentOrderOption = async (values) => {
    return await axiosInstance(options).get(`${path}/order-option`,values);
}

export const paymentVendorOption = async (values) => {
    return await axiosInstance(options).post(`${path}/vendor-option`,values);
}

export const addPayment = async (values) => {
  return await axiosInstance(options).post(`${path}/add`,values);
}


export const paymentListApi = async (values) => {
  return await axiosInstance(options).post(`${path}/list`,values);
}

export const paymentDetails = async (values) => {
  return await axiosInstance(options).get(
    `${path}/details?o_id=${values.o_id}`
  );
}

export const editPaymentManagament = async (values) => {
  return await axiosInstance(options).put(`${path}/update`,values)
}


export const deletePaymentManagament = async (values) => {
  return await axiosInstance(options).delete(`${path}/delete?p_id=${values.p_id}`
  );
}

